import Customer_history from "@components/feature/customer/Customer_history";
import Customer_notice from "@components/feature/customer/Customer_notice";
import type * as type from "@vTypes";
import * as contact from "@script/contact";
import "@css/customer.css";
import { useQueryClient } from "@tanstack/react-query";
import Footer from "@/layouts/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useContactList } from "@/hooks/useContactList";
import { SubTab, SubTabItem } from "@/layouts/SubTab";
import { Activity } from "react";

export default function Customer() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: myQuestionList = [], isPending } = useContactList(1, 10);
  const currentTab = location.pathname === "/support/inquiry" ? 1 : 0;

  async function writeQuestion(payload: type.QuestionPayload) {
    try {
      await contact.question(payload);
      await queryClient.invalidateQueries({ queryKey: ["contact_list"] });
      navigate("/support/inquiry");
    } catch (error) {
      console.log("error : ", error);
    }
  }

  return (
    <div className="p-6 overflow-auto font-pretendard">
      <SubTab aria-label="고객센터 탭">
        <SubTabItem value={0} label="공지사항" to="/support" end />
        <SubTabItem value={1} label="문의내역" to="/support/inquiry" end />
      </SubTab>

      <Activity mode={currentTab === 0 ? "visible" : "hidden"}>
        <Customer_notice writeQuestion={writeQuestion} />
      </Activity>
      <Activity mode={currentTab === 1 ? "visible" : "hidden"}>
        <Customer_history
          myQuestionList={myQuestionList}
          writeQuestion={writeQuestion}
          isPending={isPending}
        />
      </Activity>
      <Footer />
    </div>
  );
}
